import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { commonSelectors, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import mileageTrackerRatesApi from './mileageTrackerRatesApi';
import {
  MILEAGE_TRACKER_RATES_REDUCER_KEY,
  type MileageTrackerRatesState,
  type MileageTrackerRatesType,
} from './mileageTrackerRatesTypes';

const initialState: MileageTrackerRatesState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};

const entityAdapter = createResourceEntityAdapter<MileageTrackerRatesType>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: MILEAGE_TRACKER_RATES_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) => ({
    getRates: create.asyncThunk(
      async (): Promise<MileageTrackerRatesType[]> => {
        return await mileageTrackerRatesApi.fetch();
      },
      {
        pending: (state) => {
          state.isLoading = true;
        },
        fulfilled: (state, action) => {
          entityAdapter.setAll(state, action.payload);
          state.error = undefined;
        },
        rejected: (state, action) => {
          state.error = action.error;
        },
        settled(state) {
          state.isLoading = false;
          state.loadPending = false;
        },
      },
    ),
  }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const mileageTrackerRatesActions = slice.actions;
export const mileageTrackerRatesSelectors = slice.selectors;
export { slice as mileageTrackerRatesSlice };

export default slice.reducer;
